"use strict";

var _objectSpread = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectSpread");
var _objectWithoutProperties = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectWithoutProperties");
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Link = exports.Item = void 0;
var _react = _interopRequireDefault(require("react"));
var AccordionPrimitive = _interopRequireWildcard(require("@radix-ui/react-accordion"));
var Separator = _interopRequireWildcard(require("@radix-ui/react-separator"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _Icon = require("../../../deprecated/atoms/Icon");
var _globalTokens = require("../../shared/global-tokens");
var _jsxRuntime = require("react/jsx-runtime");
var StyledAccordionTrigger = (0, _styledComponents.default)(AccordionPrimitive.Trigger).withConfig({
  displayName: "Accordion__StyledAccordionTrigger",
  componentId: "sc-tdxx21-0"
})(["display:flex;flex-direction:row;align-items:center;justify-content:space-between;cursor:pointer;width:375px;height:56px;padding:", " ", ";background:", ";border-width:", " ", " ", " 0;border-style:solid;border-color:transparent;border-radius:", ";", ";color:", ";&:focus-visible{outline:none;border-color:", ";}&:hover{background:", ";color:", ";}&[data-state='open']{color:", ";svg{transform:rotate(-180deg);path{fill:", ";}}}"], _globalTokens.globalSizing['400'], _globalTokens.globalSizing['600'], function (props) {
  return props.theme.sys.color.background.neutral['2'];
}, _globalTokens.globalBorder.width.thick, _globalTokens.globalBorder.width.thick, _globalTokens.globalBorder.width.thick, function (props) {
  return props.theme.sys.size.borderradius.focusring;
}, function (props) {
  return props.theme.sys.font.subheading['1'];
}, function (props) {
  return props.theme.sys.color.text.content.main;
}, function (props) {
  return props.theme.sys.color.border.focusring;
}, function (props) {
  return props.theme.sys.color.background.primary['1'];
}, function (props) {
  return props.theme.sys.color.text.content.main;
}, function (props) {
  return props.theme.sys.color.text.content.primary;
}, function (props) {
  return props.theme.sys.color.iconfill.primary;
});
var StyledAccordionItem = (0, _styledComponents.default)(AccordionPrimitive.Item).withConfig({
  displayName: "Accordion__StyledAccordionItem",
  componentId: "sc-tdxx21-1"
})(["&:not(:last-child){border-bottom:", " solid ", ";}> a:hover{color:", ";}"], _globalTokens.globalBorder.width.thin, function (props) {
  return props.theme.sys.color.border.decorative;
}, function (props) {
  return props.theme.sys.color.text.content.main;
});
var StyledAccordionContent = (0, _styledComponents.default)(AccordionPrimitive.Content).withConfig({
  displayName: "Accordion__StyledAccordionContent",
  componentId: "sc-tdxx21-2"
})(["border-top:", " solid ", ";padding:", " ", " ", " ", ";overflow:hidden;&[data-state='open']{animation:slideDown 300ms cubic-bezier(0.87,0,0.13,1);}&[data-state='closed']{animation:slideUp 300ms cubic-bezier(0.87,0,0.13,1);}@keyframes slideDown{from{height:0;}to{height:var(--radix-accordion-content-height);}}@keyframes slideUp{from{height:var(--radix-accordion-content-height);}to{height:0;}}"], _globalTokens.globalBorder.width.thin, function (props) {
  return props.theme.sys.color.border.decorative;
}, _globalTokens.globalSpacing['100'], _globalTokens.globalSpacing['300'], _globalTokens.globalSpacing['100'], _globalTokens.globalSpacing['300']);
var StyledAccordionLink = _styledComponents.default.a.withConfig({
  displayName: "Accordion__StyledAccordionLink",
  componentId: "sc-tdxx21-3"
})(["display:flex;align-items:center;border-radius:", ";padding:6px 2px 6px ", ";margin-right:", ";margin-left:", ";", ";border-width:", " ", " ", " 0;border-style:solid;border-color:transparent;color:", ";text-transform:capitalize;&:focus-visible{outline:none;border-color:", ";}&:hover{background:", ";color:", ";}"], function (props) {
  return props.theme.sys.size.borderradius.focusring;
}, _globalTokens.globalSpacing['600'], _globalTokens.globalSpacing['300'], _globalTokens.globalSpacing['300'], function (props) {
  return props.theme.sys.font.body['1'];
}, _globalTokens.globalBorder.width.thick, _globalTokens.globalBorder.width.thick, _globalTokens.globalBorder.width.thick, function (props) {
  return props.theme.sys.color.text.content.main;
}, function (props) {
  return props.theme.sys.color.border.focusring;
}, function (props) {
  return props.theme.sys.color.background.primary['1'];
}, function (props) {
  return props.theme.sys.color.text.content.main;
});
var Accordion = function Accordion(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(AccordionPrimitive.Root, {
    type: "single",
    collapsible: true,
    children: children
  });
};
var Item = function Item(_ref2) {
  var children = _ref2.children,
    name = _ref2.name,
    onClick = _ref2.onClick,
    dataCy = _ref2['data-cy'];
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(StyledAccordionItem, {
    value: name,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(AccordionPrimitive.Header, {
      asChild: true,
      children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(StyledAccordionTrigger, {
        onClick: onClick,
        "data-cy": dataCy,
        children: [name, /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.Icon, {
          icon: 'chevronDown',
          size: 'm',
          "aria-hidden": true
        })]
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledAccordionContent, {
      children: children
    })]
  });
};
exports.Item = Item;
var Link = function Link(_ref3) {
  var children = _ref3.children,
    href = _ref3.href,
    props = _objectWithoutProperties(_ref3, ["children", "href"]);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledAccordionLink, _objectSpread({
    href: href
  }, props, {
    children: children
  }));
};
exports.Link = Link;
var HorizontalSeparator = (0, _styledComponents.default)(Separator.Root).withConfig({
  displayName: "Accordion__HorizontalSeparator",
  componentId: "sc-tdxx21-4"
})(["width:calc(100% + ", ");height:", ";background:", ";margin:", " 0;"], _globalTokens.globalSpacing['300'], _globalTokens.globalBorder.width.thin, function (props) {
  return props.theme.sys.color.border.decorative;
}, _globalTokens.globalSpacing['100']);

// ONLY USED FOR STORYBOOK DOCUMENTATION

Accordion.Separator = HorizontalSeparator;
Accordion.Item = Item;
Accordion.Link = Link;
var _default = exports.default = Accordion;